import styled from 'styled-components';

const StyledSidebarContent = styled.section`
	flex: ${({ $isNew }) => ($isNew ? `1 1 auto` : `1 0 auto`)};
	${({ $isNew }) =>
		$isNew
			? `
			overflow: auto;
			scrollbar-width: none;
			scroll-snap-type: y mandatory;
			-webkit-overflow-scrolling: touch;
			-ms-overflow-style: none;
		`
			: ``};
	display: flex;
	flex-direction: column;
`;

const SidebarContent = ({
	children,
	className = '',
	skipStep = false,
	isNew = false,
	dataBodyScrollLockIgnore = false
}) => {
	if (skipStep) return children;
	return (
		<StyledSidebarContent
			className={className}
			id="sidebar-content"
			data-at="sidebar-content"
			$isNew={isNew}
			{...(dataBodyScrollLockIgnore && { 'data-body-scroll-lock-ignore': true })}
		>
			{children}
		</StyledSidebarContent>
	);
};

export default SidebarContent;
